import React from 'react';
import { DialogBox, Button } from 'quantux-ui';
import { salmon, gray } from '../../theme';

const DIALOG_WIDTH = window.innerWidth <= 576 ? (window.innerWidth - 16) : 350;

const WarningDialog = (props) => {
  return (
    <DialogBox
      initWidth={DIALOG_WIDTH}
      top={window.innerWidth <= 576 ? 48 : null}
      left={window.innerWidth <= 576 ? 8 : null}
      initHeight={378}
      isOpen={props.show}
      onClose={props.onCancel}
      maskBackground="#004080"
      maskOpacity={0.5}
      showHeader
      zIndex='2050'
      header={{
        text: `${props.title}`,
        backColor: salmon[500],
        foreColor: salmon[500],
        overrideTheme: true,
        closeColor: '#FF6060',
        fontStyle: 'bold',
        fontSize: '20px',
        icon: 'fa fa-warning'
      }}
      closeOnMaskClick={false}
    >
      <div className='p-2'>
        {/* Warning message */}
        <div className='pt-2 pb-2'>
          {props.message}
        </div>
        <div
          className='fx mt-4 pt-2'
          style={{
            justifyContent: 'flex-end',
            borderTop: `1px solid ${gray[500]}`
          }}
        >
          <Button
            btnType='primary'
            isOutlineBtn
            className='mr-2'
            onClick={props.onCancel}
          >
            Cancel
          </Button>
          <Button
            btnType='warning'
            onClick={props.onContinue}
          >
            Continue
          </Button>
        </div>
      </div>
    </DialogBox>
  );
};

export default WarningDialog;
